import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../extended/new';
import '../dialog/AppointmentDialog';
import { IntermediateListItem, Color } from '../dataTable/dataTable';
import { Utils } from '../../utils';
import * as moment from "moment";
import "../../../node_modules/moment/locale/de.js";
import * as fs from 'fs';
import { Postbox, PostboxPaging } from "../postbox/postbox";
import "../dialog/editDeadlineDialog";
import "../dialog/editAppointmentDialog";
import { RolesAndRights } from "../../helpers/RolesAndRights";
export class TfwViewModel {
    appointments = ko.observableArray([]);
    deadlines = ko.observableArray([]);
    todos = ko.observableArray([]);
    openDashboardAppointment = ko.observable();
    appointmentId = ko.observable();
    filter = ko.observable("");
    sachbearbeiter = ko.observable("");
    selectedVB = ko.observable("");
    ProcessPartner = ko.observable("");
    ProcessPartnerId = ko.observable("");
    ProcessClient = ko.observable("");
    ProcessClientId = ko.observable("");
    Fristenkontrolle = ko.observable("");
    FristenkontrolleId = ko.observable("");
    FristenkontrolleTermine = ko.observable("");
    FristenkontrolleTermineId = ko.observable("");
    reportType = ko.observable("undone");
    reportFormat = ko.observable("word");
    hideLegend = ko.observable(false);
    rStartDate = ko.observable("");
    rEndDate = ko.observable("");
    dailyReportDate = ko.observable("");
    values = ko.observable({
        complete: ko.observable(true),
        yellow: ko.observable(true),
        red: ko.observable(true),
        bell: ko.observable(true),
        isDeleted: ko.observable(true)
    });
    types = ko.observable({
        Frist: ko.observable(true),
        Vorfrist: ko.observable(true),
        Termin: ko.observable(true)
    });
    currentID = ko.observable('');
    hasButton = ko.observable(true);
    checkDeadline = ko.observable(true);
    checkPreDeadline = ko.observable(true);
    checkApp = ko.observable(true);
    checkResub = ko.observable(true);
    tooltips = ko.observableArray([{ name: 'TypeId', col: 'subject' }]);
    showTermine = ko.observable(false);
    showFristen = ko.observable(false);
    showVorFristen = ko.observable(false);
    showFTWFilter = ko.observable(true);
    calledfirst = ko.observable(true);
    allStandorte = ko.observableArray([]);
    hasReferatCount = ko.observable(0);
    hasFKACount = ko.observable(0);
    currentRubrum = ko.observable('');
    AllReferate = ko.observable();
    showParameterMessage = ko.observable(false);
    emptyStandorte = ko.observable(true);
    extendDeadlineReason = ko.observable('');
    instancesInCase = ko.observableArray([]);
    rejectionReasonAppointment = ko.observable('');
    isAppointmentHistoryModal = ko.observable(true);
    fKAId = ko.observable('');
    fkAName = ko.observable('');
    showError = ko.observable(false);
    showExternError = ko.observable(false);
    showSuccess = ko.observable(false);
    showExternSuccess = ko.observable(false);
    showOutlookLoader = ko.observable(false);
    OutlookAccounts = ko.observableArray([]);
    selectedFilterStandort = ko.observable("");
    selectedFilterStandortKontrollblatt = ko.observable("");
    selectedFilterAccount = ko.observable("");
    selectedFilterAccountKontrollblatt = ko.observable("");
    selectedInstance = ko.observable("");
    showExternalExportSuccess = ko.observable(false);
    showOutlookExportSuccess = ko.observable(false);
    showExternalExportError = ko.observable(false);
    showOutlookExportError = ko.observable(false);
    isEditedObjTransfered = ko.observable(true);
    isViewerRole = ko.observable<boolean>(false);
    attendees = ko.observableArray([]);
    startRepDeadline = ko.observable('');
    endRepDeadline = ko.observable('');
    caseRepDeadline = ko.observable('');
    deadlineLength = ko.observable('');
    allUsers = ko.observableArray();
    showPrintLoader = ko.observable(false);
    showPrintError = ko.observable(false);
    showPrintErrorNoDeadlines = ko.observable(false);
    showPrintErrorNoAppointments = ko.observable(false);
    showReportError = ko.observable(false);
    showReportVBError = ko.observable(false);
    showReportVBMandantError = ko.observable(false);
    showReportMandantError = ko.observable(false);
    showNoDeadlinesFound = ko.observable(false);
    addres = ko.observable("");
    ReportFilter = ko.observable({
        CaseID: ko.observable(""),
        DoneOnly: ko.observable(false),
        BothTypes: ko.observable(false),
        DocFile: ko.observable(false),
        Locations: ko.observableArray(null),
        ClerkID: ko.observable(""),
        Standorte: ko.observableArray(null),
    });
    readonly DANGER_COLOR: Color = {
        color: "white",
        "background-color": "#e21b38"
    };
    currentView = ko.observable("ftw");
    filteredTodos: ko.Computed<any>;
    modalView = ko.observable(false);
    readMode = ko.observable(false);
    MailId = ko.observable(null);
    AttachmentId = ko.observable(0);
    stateForModal = ko.observable("all");
    typeForModal = ko.observable("all");
    filterType(type: string) {
        if (type == 'frist') {
            this.types().Frist(this.checkDeadline());
        }
        else if (type == 'vorfrist') {
            this.types().Vorfrist(this.checkPreDeadline());
        }
        else if (type == 'termin') {
            this.types().Termin(this.checkApp());
        }
        this.filter(this.filter());
    }
    deadlineToBeModified = ko.observable(null);
    appointmentToBeModified = ko.observable(null);
    hasVerificationRights = ko.observable(false);
    filterWithStars(item, filters) {
        if (item['stars'] && filters.indexOf(item['stars']) !== -1)
            return true;
        return false;
    }
    filterWithVB(item, filters) {
        let isInVb = false;
        if (item.entryType === 'deadline') {
            for (let i = 0; i < item.originalObj.InstanceClerks.length; i++) {
                if (item.originalObj.InstanceClerks[i].Sachbearbeiter_ID === filters)
                    isInVb = true;
            }
        }
        else {
            for (let i = 0; i < item.originalObj.VBs.length; i++) {
                if (item.originalObj.VBs[i].Sachbearbeiter_ID === filters)
                    isInVb = true;
            }
        }
        return isInVb;
    }
    filterWithType(item, filters) {
        if (item['entryTypeName'] && filters.indexOf(item['entryTypeName']) !== -1)
            return true;
        return false;
    }
    filterWithStandort(item) {
        if (item['ref'] && ko.toJS(this.selectedFilterStandort) === item['ref'])
            return true;
        return false;
    }
    filterWithFKA(item) {
        if (item['fka'] && ko.toJS(this.selectedFilterAccount) === item['fka'])
            return true;
        return false;
    }
    filterWithInstance(item) {
        if (item['instanceId'] && ko.toJS(this.selectedInstance) === item['instanceId'])
            return true;
        return false;
    }
    getNextWV(items) {
        if (items.length > 0) {
            let found = false;
            let intervall = 1;
            let notify = false;
            for (let i = items.length - 1; i >= 0; i--) {
                if (items[i].stars === "red")
                    notify = true;
                if (items[i].entryType === "resubmission") {
                    if (Number(moment(ko.toJS(items[i].date), "DD.MM.YYYY").format("YYYYMMDD")) >= Number(moment().format("YYYYMMDD"))) {
                        found = true;
                    }
                    else {
                        if (found) {
                            $("#NextWVCase").removeClass("hide");
                            $("#NextWVCaseLbl").removeClass("hide");
                            $("#grundcaseWV").val(items[i + intervall].subject);
                            $("#deadlineDateCaseWV").val(moment(items[i + intervall].date, "DD.MM.YYYY").format("YYYY-MM-DD"));
                            $("#SBcaseWV").val(items[i + intervall].SB);
                            break;
                        }
                    }
                    intervall = 1;
                }
                else {
                    intervall++;
                }
            }
            if (notify) {
                $("#redNotificationCircle").attr("style", "font-size: 0.75rem; vertical-align: middle !important; margin-bottom: 0.4rem; display: inline-block");
                $("#redNotificationCircleTFW").attr("style", "font-size: 0.5rem; vertical-align: middle !important; margin-bottom: 0.1rem; display: inline-block");
            }
        }
    }
    public getVM = () => this;
    async updateTodos(allAppointments: any, allDeadlines: any) {
        try {
            let appointments = allAppointments.Payload.Appointments;
            let deadlines = allDeadlines.Payload.Deadlines;
            let transformedAppointments = appointments.map(obj => this.transformAppointmentData(obj, "appointment"));
            if (transformedAppointments.length > 0)
                this.showTermine(true);
            else
                this.showTermine(false);
            let startAsNumber = Number(moment(ko.toJS(this.rStartDate)).format("YYYYMMDD"));
            let endAsNumber = Number(moment(ko.toJS(this.rEndDate)).format("YYYYMMDD"));
            this.showVorFristen(false);
            let transformedDeadlines = deadlines.map(obj => this.transformDeadlineData(obj, "deadline", startAsNumber, endAsNumber));
            if (transformedDeadlines.length > 0)
                this.showFristen(true);
            else
                this.showFristen(false);
            let transformedResubmissions = [];
            let todos: any;
            if (this.checkDeadline() && !this.checkResub() && this.checkApp()) {
                todos = (transformedAppointments.concat(transformedDeadlines));
            }
            if (this.checkDeadline() && this.checkResub() && !this.checkApp()) {
                todos = (transformedDeadlines.concat(transformedResubmissions));
            }
            if (!this.checkDeadline() && this.checkResub() && this.checkApp()) {
                todos = (transformedAppointments
                    .concat(transformedResubmissions));
            }
            if ((this.checkDeadline() && this.checkResub() && this.checkApp()) || !this.checkDeadline() && !this.checkResub() && !this.checkApp()) {
                todos = (transformedAppointments.concat(transformedDeadlines)
                    .concat(transformedResubmissions));
            }
            if ((this.checkDeadline() && (!this.checkResub() && !this.checkApp()))) {
                todos = transformedDeadlines;
            }
            if ((!this.checkDeadline() && this.checkResub()) && !this.checkApp()) {
                todos = transformedDeadlines;
            }
            if ((!this.checkDeadline() && (this.checkResub() && !this.checkApp()))) {
                todos = transformedResubmissions;
            }
            if ((!this.checkDeadline() && (!this.checkResub() && this.checkApp()))) {
                todos = transformedAppointments;
            }
            this.showFTWFilter((ko.toJS(this.showFristen) && ko.toJS(this.showTermine)) || (ko.toJS(this.showFristen) && ko.toJS(this.showVorFristen)) || (ko.toJS(this.showTermine) && ko.toJS(this.showVorFristen)));
            let sortedTodos = todos.sort((t1: IntermediateListItem, t2: IntermediateListItem) => {
                if (t1.dateObj.isBefore(t2.dateObj)) {
                    return 1;
                }
                else {
                    return -1;
                }
            }).map(obj => {
                if ((obj.entryTypeName === "Frist" || obj.entryType === "ecase" || obj.entryTypeName === "Vorfrist" || obj.entryTypeName === "Wiedervorlage" || obj.entryTypeName === "Termin") && !this.isViewerRole()) {
                    obj.columnActions = {
                        "number": MainViewModel.RoutingTable.generateLink(`/new/${encodeURIComponent(obj.number)}`)
                    };
                }
                return obj;
            }).reverse();
            this.todos(sortedTodos);
        }
        catch (e) {
            console.log(e);
        }
    }
    transformAppointmentData(obj: any, type: string) {
        let actionList = [];
        obj.CreatedAtDateFormated = ko.toJS(moment(ko.toJS(obj.CreationDate)).format("DD.MM.YYYY"));
        obj.CreatedFromFormated = ko.toJS(this.getUserForShorthand(obj.CreatorId));
        obj.DeletedByIdFormated = ko.toJS(this.getUserForShorthand(obj.DeletedById));
        if (obj.DeletedOn !== null) {
            obj.DeletedOnFormated = ko.toJS(moment(ko.toJS(obj.DeletedOn)).format("DD.MM.YYYY"));
        }
        else {
            obj.DeletedOnFormated = "N/A";
        }
        if (obj.EditedAtDate !== null) {
            obj.EditedAtDateFormated = ko.toJS(moment(ko.toJS(obj.EditedAtDate)).format("DD.MM.YYYY"));
            obj.EditedFromFormated = ko.toJS(this.getUserForShorthand(obj.EditorId));
        }
        if (obj.VerifiedOn !== null) {
            obj.VerifiedOnFormated = ko.toJS(moment(ko.toJS(obj.VerifiedOn)).format("DD.MM.YYYY"));
            obj.VerifiedByFormated = ko.toJS(this.getUserForShorthand(obj.VerifiedBy));
        }
        obj.StartFormated = ko.toJS(moment(ko.toJS(obj.StartDate)).format("DD.MM.YYYY HH:mm")) + " Uhr";
        obj.EndFormated = ko.toJS(moment(ko.toJS(obj.EndDate)).format("DD.MM.YYYY HH:mm")) + " Uhr";
        if (ko.toJS(obj.StartFormated).endsWith("00:00 Uhr") && ko.toJS(obj.EndFormated).endsWith("23:59 Uhr")) {
            obj.StartFormated = ko.toJS(moment(ko.toJS(obj.StartDate)).format("DD.MM.YYYY"));
            obj.EndFormated = ko.toJS(moment(ko.toJS(obj.EndDate)).format("DD.MM.YYYY"));
        }
        obj.AppointmentTypeFormated = obj.AppointmentType.Name ? obj.AppointmentType.Name : "Unbekannte Terminart";
        let history = {
            icon: "history", name: "Verlauf", action: async () => {
                if (ko.toJS(this.modalView))
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 0 }, "ShowAppointmentHistory");
                else
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 0 }, "EditAppointmentModalData");
            }
        };
        actionList.push(history);
        let verificationCheckMuted = {
            icon: "check-double text-muted", name: "Dieser Termin muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => { }
        };
        let verificationCheck = {
            icon: "check-double", name: "Dieser Termin muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => {
                if (ko.toJS(this.modalView))
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 1 }, "ShowAppointmentHistory");
                else
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 1 }, "EditAppointmentModalData");
            }
        };
        let editAppointment = {
            icon: "pencil-alt", name: "Bearbeiten", action: () => {
                this.openDashboardAppointment(true);
                this.IsEditMode(true);
                this.appointmentId(obj.Id);
                Postbox.publisher().publish(obj.Id, "FillAppointmentDataWithID");
                if (ko.toJS(this.modalView)) {
                    PostboxPaging.publisher().publish(obj, "ShowAppointmentEditionModal");
                }
                else {
                    $("#AppointmentTFWmodal").modal("show");
                }
            }
        };
        let deleteAppointment = {
            icon: "trash-alt",
            name: "Löschen",
            action: async () => {
                if (ko.toJS(this.modalView))
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 3 }, "ShowAppointmentHistory");
                else
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 3 }, "EditAppointmentModalData");
            }
        };
        let checkAppointment = {
            icon: "check",
            name: "Abhaken",
            action: async () => {
                if (ko.toJS(this.modalView))
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 2 }, "ShowAppointmentHistory");
                else
                    PostboxPaging.publisher().publish({ Appointment: obj, Mode: 2 }, "EditAppointmentModalData");
            }
        };
        if (!obj.Completed && !obj.IsDeleted) {
            if (!this.isViewerRole()) {
                actionList.push(deleteAppointment);
                if (obj.HasToBeVerified) {
                    if (obj.VerifiedOn !== null) {
                        actionList.push(editAppointment);
                    }
                }
                else {
                    actionList.push(editAppointment);
                }
                if (obj.HasToBeVerified) {
                    if (obj.VerifiedOn !== null && obj.IsVerificationAccepted)
                        actionList.push(checkAppointment);
                }
                else
                    actionList.push(checkAppointment);
            }
        }
        let stars = "";
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        let d = new Date(obj.EndDate);
        d.setHours(0, 0, 0, 0);
        if (obj.Completed) {
            stars = "complete";
        }
        else {
            if (d < today && !obj.IsDeleted) {
                stars = "red";
            }
            else if (obj.IsDeleted) {
                stars = "isDeleted";
            }
            else {
                stars = "yellow";
            }
        }
        if (ko.toJS(this.AllReferate).length > 0) {
            let refs = ko.toJS(this.AllReferate);
            let loc = refs.filter(a => a.Id == obj.LocationId);
            if (loc.length === 1)
                obj.locationID = loc[0].Id;
            else
                obj.locationID = "";
        }
        else
            obj.locationID = "";
        obj.fka = obj.Fka;
        if (ko.toJS(this.instancesInCase).length > 0) {
            obj.CourtInstanceId = obj.InstanceId;
            for (let inst of ko.toJS(this.instancesInCase)) {
                if (obj.InstanceId === inst.InstanceId) {
                    obj.Instance = inst.InstanceType + " " + inst.CourtId;
                    break;
                }
            }
            if (!obj.Instance)
                obj.Instance = "";
        }
        if (!this.isViewerRole()) {
            if (obj.HasToBeVerified && obj.VerifiedOn === null && obj.CreatorId === RNSAPI.getCurrentLoggedInUser().ShortHandSymbol && !obj.IsDeleted) {
                actionList.push(verificationCheckMuted);
            }
            if (obj.HasToBeVerified && obj.VerifiedOn === null && obj.CreatorId !== RNSAPI.getCurrentLoggedInUser().ShortHandSymbol && !obj.IsDeleted) {
                actionList.push(verificationCheck);
            }
        }
        let vbs = "";
        for (let vb of obj.VBs) {
            if (vbs === "")
                vbs = vb.Sachbearbeiter_ID;
            else
                vbs = vbs + ' ' + vb.Sachbearbeiter_ID;
        }
        return new IntermediateListItem(stars, type, nameTable[type], obj.StartDate, obj.AppointmentSubject, obj.CaseId, obj, actionList, undefined, obj.Rubrum, obj.SB, obj.AppointmentNote, obj.locationID, obj.fka, obj.Instance, obj.CourtInstanceId, null, vbs);
    }
    transformDeadlineData(obj: any, type: string, start: Number, end: Number) {
        let deadlineAsNumber = Number(moment(obj.Deadline).format("YYYYMMDD"));
        if (deadlineAsNumber < start || deadlineAsNumber > end) {
            this.showVorFristen(true);
            type = "predeadline";
        }
        obj.PreDeadline2 = ko.toJS(moment(ko.toJS(obj.PreDeadline)).format("DD.MM.YYYY"));
        obj.PreDeadlinesFormated = [];
        for (let i = 0; i < obj.PreDeadlines.length; i++) {
            var formatedPreDeadline = ko.toJS(moment(ko.toJS(obj.PreDeadlines[i])).format("DD.MM.YYYY"));
            obj.PreDeadline2 = obj.PreDeadline2 + "      " + formatedPreDeadline;
            obj.PreDeadlinesFormated.push(formatedPreDeadline);
        }
        let check = [
            {
                icon: "check", name: "Abschließen", action: async () => {
                    if (ko.toJS(this.modalView))
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 4 }, "ShowDeadlineHistory");
                    else
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 4 }, "EditDeadlineModalData");
                }
            }
        ];
        let delegate = [
            {
                icon: "user-circle", name: "Delegieren", action: async () => {
                    if (ko.toJS(this.modalView))
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 3 }, "ShowDeadlineHistory");
                    else
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 3 }, "EditDeadlineModalData");
                }
            }
        ];
        let extendable = [
            {
                icon: "pencil-alt", name: "Bearbeiten", action: async () => {
                    if (ko.toJS(this.modalView))
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 2 }, "ShowDeadlineHistory");
                    else
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 2 }, "EditDeadlineModalData");
                    ;
                }
            }
        ];
        let verificationCheckMuted = {
            icon: "check-double text-muted", name: "Diese Frist muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => { }
        };
        let verificationCheck = {
            icon: "check-double", name: "Diese Frist muss noch von einem zweiten Sachbearbeiter freigegeben werden!", action: async () => {
                if (ko.toJS(this.modalView))
                    PostboxPaging.publisher().publish({ Deadline: obj, Mode: 1 }, "ShowDeadlineHistory");
                else
                    PostboxPaging.publisher().publish({ Deadline: obj, Mode: 1 }, "EditDeadlineModalData");
            }
        };
        let actionList = [
            {
                icon: "history", name: "Verlauf", action: async () => {
                    if (ko.toJS(this.modalView))
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 0 }, "ShowDeadlineHistory");
                    else
                        PostboxPaging.publisher().publish({ Deadline: obj, Mode: 0 }, "EditDeadlineModalData");
                }
            }
        ];
        obj.fka = obj.FKAName;
        if (obj.Status !== "complete" && !this.isViewerRole()) {
            if (!ko.toJS(this.hasVerificationRights))
                actionList.push(delegate[0]);
            if (!obj.IsEmergencyDeadline) {
                if (!obj.openVerification) {
                    actionList.push(extendable[0]);
                }
            }
            if (!obj.openVerification)
                actionList.push(check[0]);
            if (obj.openVerificationRejected) {
                if (obj.openVeriticationType === 0 || obj.openVeriticationType === 3) {
                    actionList.push(extendable[0]);
                    if (obj.openVeriticationType === 3)
                        actionList.push(check[0]);
                }
                else {
                    if (obj.openVerification && obj.openVerificationUser === RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                        actionList.push(verificationCheckMuted);
                    if (obj.openVerification && obj.openVerificationUser !== RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                        actionList.push(verificationCheck);
                }
            }
            if (obj.openVerification && obj.openVerificationRejected === false && obj.openVerificationUser === RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                actionList.push(verificationCheckMuted);
            if (obj.openVerification && obj.openVerificationRejected === false && obj.openVerificationUser !== RNSAPI.getCurrentLoggedInUser().ShortHandSymbol)
                actionList.push(verificationCheck);
        }
        return new IntermediateListItem(obj.Status, type, nameTable[type], obj.Deadline, obj.TypeDescription, obj.CaseId, obj, actionList, undefined, obj.Rubrum, obj.SB, obj.Note, obj.locationID, obj.fka, obj.InstanceData ? obj.InstanceData.CourtInstanceName + ' ' + obj.InstanceData.CourtName : '', obj.InstanceData ? obj.InstanceData.Id : undefined, obj.PreDeadline2, obj.VBs, obj.CurrentFVA);
    }
    getUserForShorthand(shorthand: string) {
        for (let i = 0; i < this.allUsers().length; i++) {
            if (ko.toJS(this.allUsers())[i].Shorthandsymbol === shorthand)
                return ko.toJS(this.allUsers())[i].Name.replace('Bitte wählen Sie', '').replace('Frau', '').replace('Herr', '');
        }
        return "";
    }
    async getAllUsers() {
        let res = (await RNSAPI.getLawFirmUsers()).Payload.Users;
        this.allUsers(res);
    }
    async printDailyReportDeadline() {
        let DocFile = ko.toJS(this.reportFormat) === "word";
        this.dailyReportDate((<HTMLInputElement>document.getElementById("dailyReportDate")).value);
        this.showPrintLoader(true);
        try {
            let res = await RNSAPI.reportDeadlinePerDay(moment(ko.toJS(this.dailyReportDate), "YYYY-MM-DD"), ko.toJS(this.selectedFilterStandortKontrollblatt), DocFile);
            if (res.Type === "ReportPerDaySuccessful") {
                setTimeout(() => { }, 1000);
                let from = moment(ko.toJS(this.dailyReportDate), "YYYY-MM-DD").format("DD.MM.YYYY");
                let element = document.createElement("a");
                let fileExtension = DocFile ? "docx" : "pdf";
                let fileType = DocFile ? "data:application/octet-stream;charset=utf-16le;base64," : "data:application/pdf;base64,";
                let fileName = `Kontrollblatt vom  ${from}.${fileExtension}`;
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(res.Payload.DocumentData);
                }
                else {
                    element.setAttribute("href", fileType + res.Payload.DocumentData);
                    element.setAttribute("download", fileName);
                    element.style.display = "none";
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    $("#reportDailyDeadlineModal").modal("hide");
                    this.showPrintLoader(false);
                }
            }
            else if (res.Type === "ReportPerDayNoEntries") {
                this.showPrintErrorNoDeadlines(true);
                this.showPrintError(false);
                this.showPrintLoader(false);
                setTimeout(() => {
                    this.showPrintErrorNoDeadlines(false);
                }, 3000);
            }
            else {
                this.showPrintErrorNoDeadlines(false);
                this.showPrintError(true);
                this.showPrintLoader(false);
                setTimeout(() => {
                    this.showPrintError(false);
                }, 3000);
            }
        }
        catch {
            this.showPrintLoader(false);
            this.showPrintErrorNoDeadlines(false);
            this.showPrintError(true);
            setTimeout(() => {
                this.showPrintError(false);
            }, 3000);
        }
    }
    async printAppointments() {
        let doneOnly = false;
        let BothTypes = false;
        let prefix = "";
        let startRepApp = (document.getElementById("startRepApp") as HTMLInputElement).value;
        let endRepApp = (document.getElementById("endRepApp") as HTMLInputElement).value;
        let DocFile = ko.toJS(this.reportFormat) === "word";
        switch (ko.toJS(this.reportType)) {
            case "undone":
                prefix = "Unerledigt";
                doneOnly = false;
                BothTypes = false;
                break;
            case "done":
                prefix = "Erledigt";
                doneOnly = true;
                BothTypes = false;
                ;
                break;
            case "all":
                prefix = "Alle";
                doneOnly = false;
                BothTypes = true;
                break;
        }
        this.showParameterMessage(false);
        try {
            this.showPrintLoader(true);
            let res = await RNSAPI.reportAppointments(moment(startRepApp, "YYYY-MM-DD"), moment(endRepApp, "YYYY-MM-DD"), ko.toJS(this.FristenkontrolleTermineId()), doneOnly, BothTypes, DocFile);
            if (res.Type === "AppointmentReportSuccessful") {
                let fileExtension = DocFile ? "docx" : "pdf";
                let fileType = DocFile ? "data:application/octet-stream;charset=utf-16le;base64," : "data:application/pdf;base64,";
                let fileName = `Terminübersicht von ${startRepApp} bis ${endRepApp} - (${prefix}).${fileExtension}`;
                let element = document.createElement("a");
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    let blob = new Blob([res.Payload.DocumentData], { type: fileType });
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                }
                else {
                    element.setAttribute("href", fileType + res.Payload.DocumentData);
                    element.setAttribute("download", fileName);
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                }
                this.FristenkontrolleTermineId("");
                this.FristenkontrolleTermine("");
                $("#reportAppointmentModal").modal("hide");
                this.showPrintLoader(false);
                this.caseRepDeadline("");
            }
            else if (res.Type === "AppointmentReportNoEntries") {
                this.showPrintErrorNoAppointments(true);
                this.showPrintLoader(false);
                setTimeout(() => {
                    this.showPrintErrorNoAppointments(false);
                }, 3000);
            }
        }
        catch (error) {
            console.error("Fehler beim Abrufen der Termine:", error);
            this.showPrintLoader(false);
            this.showParameterMessage(true);
        }
    }
    async printDeadline() {
        let prefix = "";
        this.showParameterMessage(false);
        this.startRepDeadline((<HTMLInputElement>document.getElementById("startRepDeadline")).value);
        this.endRepDeadline((<HTMLInputElement>document.getElementById("endRepDeadline")).value);
        let DocFile = ko.toJS(this.reportFormat) === "word";
        switch (ko.toJS(this.reportType)) {
            case "undone":
                prefix = "Unerledigte";
                this.ReportFilter().BothTypes(false);
                this.ReportFilter().DoneOnly(false);
                break;
            case "done":
                prefix = "Erledigte";
                this.ReportFilter().BothTypes(false);
                this.ReportFilter().DoneOnly(true);
                break;
            case "all":
                prefix = "Alle";
                this.ReportFilter().BothTypes(true);
                this.ReportFilter().DoneOnly(false);
                break;
        }
        this.ReportFilter().CaseID(ko.toJS(this.caseRepDeadline));
        this.AllReferate()?.forEach((r) => {
            if (r.Checked) {
                this.ReportFilter().Standorte.push(r.Id);
            }
        });
        this.ReportFilter().ClerkID("");
        this.ReportFilter().ClerkID(ko.toJS(this.FristenkontrolleId));
        this.ReportFilter().DocFile(DocFile);
        try {
            this.showPrintLoader(true);
            let res = await RNSAPI.reportDeadline(moment(ko.toJS(this.startRepDeadline), "YYYY-MM-DD"), moment(ko.toJS(this.endRepDeadline), "YYYY-MM-DD"), ko.toJS(this.ReportFilter));
            if (res.Type === "ReportSuccessful") {
                setTimeout(() => { }, 1000);
                let from = moment(ko.toJS(this.startRepDeadline), "YYYY-MM-DD").format("DD.MM.YYYY");
                let to = moment(ko.toJS(this.endRepDeadline), "YYYY-MM-DD").format("DD.MM.YYYY");
                let fileExtension = DocFile ? "docx" : "pdf";
                let fileType = DocFile ? "data:application/octet-stream;charset=utf-16le;base64," : "data:application/pdf;base64,";
                let fileName = `Fristenübersicht von ${from} bis ${to} - ${ko.toJS(this.FristenkontrolleId())} - (${prefix}).${fileExtension}`;
                let element = document.createElement("a");
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    let blob = new Blob([res.Payload.DocumentData], { type: fileType });
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                }
                else {
                    element.setAttribute("href", fileType + res.Payload.DocumentData);
                    element.setAttribute("download", fileName);
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    $("#reportDailyDeadlineModal").modal("hide");
                    this.showPrintLoader(false);
                }
                $("#reportDeadlineModal").modal("hide");
                $("#historyOrVerifcationDeadlineModal").modal("hide");
                this.startRepDeadline("");
                this.endRepDeadline("");
                this.caseRepDeadline("");
                this.FristenkontrolleId("");
                this.Fristenkontrolle("");
                this.ReportFilter().DoneOnly(false);
                this.ReportFilter().CaseID("");
                this.ReportFilter().Locations([]);
                this.ReportFilter().ClerkID("");
            }
            else {
                this.showPrintLoader(false);
                this.showParameterMessage(true);
            }
        }
        catch {
            this.showPrintLoader(false);
            this.showParameterMessage(true);
        }
    }
    async printDeadlineLeadpartner() {
        let doneOnly = false;
        let BothTypes = false;
        let prefix = "";
        this.startRepDeadline((<HTMLInputElement>document.getElementById("startRepDeadlineVB")).value);
        this.endRepDeadline((<HTMLInputElement>document.getElementById("endRepDeadlineVB")).value);
        let DocFile = ko.toJS(this.reportFormat) === "word";
        switch (ko.toJS(this.reportType)) {
            case "undone":
                prefix = "Unerledigte";
                doneOnly = false;
                BothTypes = false;
                break;
            case "done":
                prefix = "Erledigte";
                doneOnly = true;
                BothTypes = false;
                break;
            case "all":
                prefix = "Alle";
                BothTypes = true;
                doneOnly = false;
                break;
        }
        this.showReportVBError(false);
        if (!this.ProcessPartnerId()) {
            this.showReportVBError(true);
            return;
        }
        this.showReportVBError(false);
        this.showPrintLoader(true);
        try {
            let data = await RNSAPI.reportLeadPartnerDeadline(moment(ko.toJS(this.startRepDeadline), "YYYY-MM-DD"), moment(ko.toJS(this.endRepDeadline), "YYYY-MM-DD"), ko.toJS(this.ProcessPartnerId()), doneOnly, BothTypes, DocFile);
            let element = document.createElement("a");
            let fileExtension = DocFile ? "docx" : "pdf";
            let fileType = DocFile ? "data:application/octet-stream;charset=utf-16le;base64," : "data:application/pdf;base64,";
            let fileName = `Verfahrensbearbeiter - Fristenübersicht von ${ko.toJS(this.startRepDeadline)} bis ${ko.toJS(this.endRepDeadline)}- (${prefix}) - ${ko.toJS(this.ProcessPartnerId())}.${fileExtension}`;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(data);
            }
            else {
                element.setAttribute("href", fileType + data);
                element.setAttribute("download", fileName);
                element.style.display = "none";
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
            element.style.display = "none";
            document.body.appendChild(element);
            document.body.removeChild(element);
            this.ProcessPartner("");
            this.ProcessPartnerId("");
            this.showPrintLoader(false);
            this.showReportVBError(false);
            $("#reportLeadpartnerDeadlineModal").modal("hide");
        }
        catch (error) {
            if (error.responseJSON && error.responseJSON.Message === "No deadlines/preDeadlines found") {
                this.showNoDeadlinesFound(true);
            }
            else {
                console.log("Fehler: ", error);
                this.showReportError(true);
            }
            this.showPrintLoader(false);
            this.showReportError(true);
            setTimeout(() => {
                this.showReportError(false);
                this.showReportVBError(false);
                this.showNoDeadlinesFound(false);
            }, 5000);
        }
    }
    async printDeadlineClient() {
        let doneOnly = false;
        let BothTypes = false;
        let prefix = "";
        this.startRepDeadline((<HTMLInputElement>document.getElementById("startRepDeadlineClient")).value);
        this.endRepDeadline((<HTMLInputElement>document.getElementById("endRepDeadlineClient")).value);
        let DocFile = ko.toJS(this.reportFormat) === "word";
        switch (ko.toJS(this.reportType)) {
            case "undone":
                prefix = "Unerledigte";
                doneOnly = false;
                BothTypes = false;
                break;
            case "done":
                prefix = "Erledigte";
                doneOnly = true;
                BothTypes = false;
                break;
            case "all":
                prefix = "Alle";
                BothTypes = true;
                break;
        }
        this.showReportVBMandantError(false);
        if (!this.ProcessClientId()) {
            this.showReportVBMandantError(true);
            return;
        }
        try {
            this.showPrintLoader(true);
            let data = await RNSAPI.reportClientDeadline(moment(ko.toJS(this.startRepDeadline), "YYYY-MM-DD"), moment(ko.toJS(this.endRepDeadline), "YYYY-MM-DD"), ko.toJS(this.ProcessClientId()), doneOnly, BothTypes, DocFile);
            let element = document.createElement("a");
            let fileExtension = DocFile ? "docx" : "pdf";
            let fileType = DocFile ? "data:application/octet-stream;charset=utf-16le;base64," : "data:application/pdf;base64,";
            let fileName = `Mandant - Fristenübersicht von ${ko.toJS(this.startRepDeadline)} bis ${ko.toJS(this.endRepDeadline)}- (${prefix}) - ${ko.toJS(this.ProcessClientId())}.${fileExtension}`;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(data);
            }
            else {
                element.setAttribute("href", fileType + data);
                element.setAttribute("download", fileName);
                element.style.display = "none";
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
            this.ProcessClient("");
            this.ProcessClientId("");
            this.showPrintLoader(false);
            this.showReportVBMandantError(false);
            $("#reportClientDeadlineModal").modal("hide");
        }
        catch (error) {
            if (error.responseJSON && error.responseJSON.Message === "No deadlines found") {
                this.showNoDeadlinesFound(true);
            }
            else {
                console.log("Fehler: ", error);
            }
            this.showPrintLoader(false);
            this.showReportMandantError(true);
            setTimeout(() => {
                this.showNoDeadlinesFound(false);
                this.showReportMandantError(false);
                this.showReportVBMandantError(false);
            }, 5000);
        }
    }
    async download(name: string, DocumentData: any) {
        let element = document.createElement('a');
        let doc = DocumentData;
        let IsRTF = atob(doc.DocumentData.substr(0, 50)).indexOf("rtf") !== -1;
        let type = IsRTF ? "rtf" : doc.OLE2Type.trim().toLowerCase();
        let blob = Utils.base64ToBlob(doc.DocumentData, 'application/octet-stream');
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
        }
        else {
            element.setAttribute('href', 'data:application/octet-stream;charset=utf-16le;base64,' + doc.DocumentData);
            element.setAttribute('download', `${name.trim()}.${type}`);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }
    public async update() {
        let allAppointments;
        let allDeadlines;
        if (ko.toJS(this.currentID) !== '')
            allAppointments = await RNSAPI.getAppointmentsForCase(ko.toJS(this.currentID), moment("2000-01-01", "YYYY-MM-DD").toDate(), moment("2099-12-31", "YYYY-MM-DD").toDate());
        else
            allAppointments = await RNSAPI.getAppointmentsByRange(moment(ko.toJS(this.rStartDate)).toDate(), moment(ko.toJS(this.rEndDate)).add("1", "day").toDate());
        if (ko.toJS(this.currentID) !== '') {
            allDeadlines = await RNSAPI.getDeadlinesForCase(ko.toJS(this.currentID));
            let resCase = (await RNSAPI.getExtendedCase(ko.toJS(this.currentID))).Payload;
            this.instancesInCase(resCase.Instances);
        }
        else {
            allDeadlines = await RNSAPI.getDeadlinesByRange(moment(ko.toJS(this.rStartDate)), moment(ko.toJS(this.rEndDate)));
            this.instancesInCase([]);
        }
        this.updateTodos(allAppointments, allDeadlines);
    }
    newAkteFrist() {
        let obj = {
            SachbearbeiterId: ko.observable(RNSAPI.User().username),
            Sachbearbeiter: ko.observable(null),
            Clerk: ko.observable(null),
            CaseId: ko.observable(null),
            Rubrum: ko.observable("Kein Rubrum vorhanden."),
            DeadlineNumber: ko.observable("-/-"),
            DeadlineText: ko.observable(null),
            CompletedBy: ko.observable(""),
            CompletionDate: ko.observable(""),
            CreatedBy: ko.observable(""),
            StartDate: ko.observable(moment().format("YYYY-MM-DD")),
            PreDeadline: ko.computed(() => {
                if (this.predeadlineNr().startsWith("w")) {
                    let weeks = this.predeadlineNr()[1] + this.predeadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(weeks, "w");
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.predeadlineNr().startsWith("m")) {
                    let months = this.predeadlineNr()[1] + this.predeadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(months, "M");
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.predeadlineNr().startsWith("j")) {
                    let year = this.predeadlineNr()[1] + this.predeadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(year, "y");
                    return FristDay.format("YYYY-MM-DD");
                }
                else {
                    return moment().format("YYYY-MM-DD");
                }
            }),
            TheDeadline: ko.computed(() => {
                if (this.deadlineNr().startsWith("w")) {
                    let weeks = this.deadlineNr()[1] + this.deadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(weeks, "w");
                    if (FristDay.day() == 0) {
                        FristDay.add(1, 'day');
                    }
                    else if (FristDay.day() == 6) {
                        FristDay.add(2, 'day');
                    }
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.deadlineNr().startsWith("m")) {
                    let months = this.deadlineNr()[1] + this.deadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(months, "M");
                    if (FristDay.day() == 0) {
                        FristDay.add(1, 'day');
                    }
                    else if (FristDay.day() == 6) {
                        FristDay.add(2, 'day');
                    }
                    return FristDay.format("YYYY-MM-DD");
                }
                else if (this.deadlineNr().startsWith("j")) {
                    let year = this.deadlineNr()[1] + this.deadlineNr()[2];
                    let today = moment().format("YYYY-MM-DD");
                    let FristDay = moment(this.akteFrist().StartDate(), "YYYY-MM-DD").add(year, "y");
                    if (FristDay.day() == 0) {
                        FristDay.add(1, 'day');
                    }
                    else if (FristDay.day() == 6) {
                        FristDay.add(2, 'day');
                    }
                    return FristDay.format("YYYY-MM-DD");
                }
                else {
                }
            })
        };
        return ko.observable(obj);
    }
    ;
    deadlineNr = ko.observable("");
    predeadlineNr = ko.observable("");
    IsEditMode = ko.observable(false);
    akteFrist = this.newAkteFrist();
    async verifyRejectAppointment() {
        this.rejectionReasonAppointment("");
        $("#reasonForRejectionAppointment_inp").removeClass("has-error");
        $("#rejectVerifyConclusionAppointment_Body").removeClass("hide");
        $("#rejectVerifyConclusionAppointment_Body").addClass("show");
        $("#verifyConclusionAppointment_Body").removeClass("show");
        $("#verifyConclusionAppointment_Body").addClass("hide");
    }
    async abortRejectAppointment() {
        $("#verifyConclusionAppointment_Body").removeClass("hide");
        $("#verifyConclusionAppointment_Body").addClass("show");
        $("#rejectVerifyConclusionAppointment_Body").removeClass("show");
        $("#rejectVerifyConclusionAppointment_Body").addClass("hide");
    }
    async getFKA(caseId) {
        let AccountId = await this.getFristenKalenderForCaseId(caseId);
        let result = (await RNSAPI.getOutlook());
        if (result.Type === "GetAccountsSuccessful") {
            let res = result.Payload.OutlookAccounts;
            if (res.length > 0) {
                let account = "";
                let accountId = "";
                for (let acc of res) {
                    if (acc.OutlookAccountID === AccountId.FKAId) {
                        account = acc.UserLogin;
                        accountId = acc.OutlookAccountID;
                    }
                }
                this.fkAName(account);
                this.fKAId(accountId);
            }
        }
    }
    async getFristenKalenderForCaseId(caseId): Promise<any> {
        let result = { FKA: "", FKAId: "" };
        if (caseId !== "" && caseId !== null) {
            let res = (await RNSAPI.getExtendedCase(caseId)).Payload;
            result.FKA = res.Akte.DeadlineCalendarAccount;
            result.FKAId = res.Akte.DeadlineCalendarAccountId;
            this.attendees(res.Akte.WeitereSachbearbeiterRecords);
        }
        return result;
    }
    async getOutlookAccounts() {
        let result = (await RNSAPI.getOutlook());
        if (result.Type === "GetAccountsSuccessful") {
            let res = result.Payload.OutlookAccounts;
            this.hasFKACount(res.length);
            this.OutlookAccounts(res);
        }
        else
            this.OutlookAccounts([]);
    }
    async pickCase5() {
        let cases = [];
        await RNSAPI.getCasesOverview().then((data) => {
            cases = data as any;
        }).catch((error) => {
            cases = [];
        });
        this.pickGeneric("Akte", ["caseid", "rubrum", "court_caseid_1", "refId"], ["Akte", "Rubrum", "AZ-Gericht 1. Instanz", "Standort"], cases);
        this.modalHandleSelection((selectedObject) => {
            this.currentRubrum(selectedObject()["rubrum"]);
            this.filter(selectedObject()["caseid"]);
        });
        $('#modal').modal('show');
    }
    ;
    async pickClerk5() {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Fristenkontrolle wählen", ["Sachbearbeiter"], ["Fristenkontrolle"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            this.sachbearbeiter(selectedObject()["Sachbearbeiter"]);
        });
        $('#modal').modal('show');
    }
    ;
    async pickVB() {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Verfahrensbearbeiter wählen", ["Sachbearbeiter"], ["Verfahrensbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            this.selectedVB(selectedObject()["Sachbearbeiter_ID"]);
        });
        $('#modal').modal('show');
    }
    async pickVBReport(position) {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter((s) => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Verfahrensbearbeiter wählen", ["Sachbearbeiter"], ["Verfahrensbearbeiter"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            if (position === "FristenkontrolleTermine") {
                this.FristenkontrolleTermine(selectedObject()["Sachbearbeiter"]);
                this.FristenkontrolleTermineId(selectedObject()["Sachbearbeiter_ID"]);
            }
            else if (position === "ProcessPartner") {
                this.ProcessPartner(selectedObject()["Sachbearbeiter"]);
                this.ProcessPartnerId(selectedObject()["Sachbearbeiter_ID"]);
            }
        });
        $("#modal").modal("show");
    }
    async pickClientInstance() {
        await RNSAPI.getAdressPagin(2)
            .then((addresses) => {
            let addr = addresses as any;
            this.pickGeneric("Mandant wählen", ["FormOfAddress", "FirstName", "Name"], ["Rechtform", "Vorname", "Nachname"], addr);
            this.modalHandleSelection((selectedObject) => {
                let firstName = selectedObject()["FirstName"] === null
                    ? ""
                    : selectedObject()["FirstName"];
                this.ProcessClient(firstName + " " + selectedObject()["Name"]);
                this.ProcessClientId(selectedObject()["Keyword"]);
            });
            $("#modal").modal("show");
        })
            .catch((error) => {
            console.log(error);
            this.addres("");
        });
    }
    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    }
    ;
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection = ko.observable();
    TermiCount = ko.observable(0);
    async getReferate() {
        let referate = (await RNSAPI.getReferate()).Payload.Units;
        this.hasReferatCount(referate.length);
        let ref = referate.map((r) => {
            r.Checked = false;
            return r;
        });
        this.AllReferate(ref);
    }
    constructor(params: any) {
        this.isViewerRole(RolesAndRights.isViewerRole());
        let user = RNSAPI.getCurrentLoggedInUser();
        if (user.UseVerificationWorkflow === "1") {
            this.hasVerificationRights(true);
        }
        moment.locale("de");
        this.hasButton(true);
        if (params.hideLegend) {
            this.hideLegend(true);
        }
        if (params.id !== undefined) {
            this.currentID(ko.toJS(params.id));
            this.filter(ko.toJS(params.id));
            this.hasButton(false);
            Postbox.publisher().publish("", "checkReferate");
        }
        else {
            this.rStartDate(ko.toJS(moment().format("YYYY-MM-DD")));
            this.rEndDate(ko.toJS(moment().format("YYYY-MM-DD")));
        }
        if (ko.toJS(params.modalView) === true) {
            if (params.MailId)
                this.MailId(ko.toJS(params.MailId));
            if(params.AttachmentId)
                this.AttachmentId(ko.toJS(params.AttachmentId));
            if (params.readMode)
                this.readMode(ko.toJS(params.readMode));
            this.modalView(true);
            if (params.instanceId)
                this.selectedInstance(ko.toJS(params.instanceId));
            this.stateForModal.subscribe(() => {
                switch (ko.toJS(this.stateForModal)) {
                    case "completed":
                        this.values().complete(true);
                        this.values().yellow(false);
                        this.values().red(false);
                        this.values().isDeleted(false);
                        break;
                    case "pending":
                        this.values().complete(false);
                        this.values().yellow(true);
                        this.values().red(false);
                        this.values().isDeleted(false);
                        break;
                    case "expired":
                        this.values().complete(false);
                        this.values().yellow(false);
                        this.values().red(true);
                        this.values().isDeleted(false);
                        break;
                    case "deleted":
                        this.values().complete(false);
                        this.values().yellow(false);
                        this.values().red(false);
                        this.values().isDeleted(true);
                        break;
                    default:
                        this.values().complete(true);
                        this.values().yellow(true);
                        this.values().red(true);
                        this.values().isDeleted(true);
                }
            });
            this.typeForModal.subscribe(() => {
                switch (ko.toJS(this.typeForModal)) {
                    case "deadlines":
                        this.types().Termin(false);
                        this.types().Frist(true);
                        break;
                    case "appointments":
                        this.types().Termin(true);
                        this.types().Frist(false);
                        break;
                    default:
                        this.types().Termin(true);
                        this.types().Frist(true);
                }
            });
        }
        this.getAllUsers();
        this.update();
        Postbox.publisher().subscribe(() => {
            this.update();
        }, 'updateTFW');
        this.filteredTodos = ko.computed({
            owner: this,
            read: () => {
                let filter = this.filter();
                let sachbearbeiter = this.sachbearbeiter();
                let vb = this.selectedVB();
                let filters = [];
                if (this.values().complete()) {
                    filters.push('complete');
                }
                else {
                    filters.indexOf('complete') !== -1 ? filters.splice(filters.indexOf('complete'), 1) : null;
                }
                if (this.values().yellow()) {
                    filters.push('yellow');
                }
                else {
                    filters.indexOf('yellow') !== -1 ? filters.splice(filters.indexOf('yellow'), 1) : null;
                }
                if (this.values().red()) {
                    filters.push('red');
                }
                else {
                    filters.indexOf('red') !== -1 ? filters.splice(filters.indexOf('red'), 1) : null;
                }
                if (this.values().isDeleted()) {
                    filters.push("isDeleted");
                }
                else {
                    filters.indexOf("isDeleted") !== -1
                        ? filters.splice(filters.indexOf("isDeleted"), 1)
                        : null;
                }
                const filterTypes = Object.keys(this.types()).filter(item => this.types()[item]());
                let items = this.todos();
                if (ko.toJS(this.selectedFilterStandort()) !== "")
                    items = items.filter(item => this.filterWithStandort(item));
                if (ko.toJS(this.selectedFilterAccount()) !== "")
                    items = items.filter(item => this.filterWithFKA(item));
                if (ko.toJS(this.selectedInstance()) !== "")
                    items = items.filter(item => this.filterWithInstance(item));
                if (filters.length) {
                    items = items.filter(item => this.filterWithStars(item, filters));
                }
                if (filterTypes.length) {
                    items = items.filter(item => this.filterWithType(item, filterTypes));
                }
                if (filter) {
                    items = items.filter(item => item['number'] && item['number'].indexOf(filter) !== -1);
                }
                if (sachbearbeiter) {
                    items = items.filter(item => item['SB'] && item['SB'].includes(sachbearbeiter));
                }
                if (vb) {
                    items = items.filter(item => this.filterWithVB(item, vb));
                }
                if (ko.toJS(this.currentID) !== '' && ko.toJS(this.currentID) !== "undefined") {
                    this.getNextWV(items);
                }
                return items;
            }
        });
        this.rStartDate.subscribe(() => this.update());
        this.rEndDate.subscribe(() => this.update());
        Postbox.publisher().subscribe((start: string, end: string) => {
            this.startRepDeadline(start);
            this.endRepDeadline(end);
        }, 'UpdateRepDeadlines');
        this.getReferate();
        this.getOutlookAccounts();
    }
}
let nameTable: {
    [key: string]: string;
} = {
    "appointment": "Termin",
    "deadline": "Frist",
    "predeadline": "Vorfrist",
    "inbox": "Posteingang",
    "resubmission": "Wiedervorlage",
    "ecase": "EAkte"
};
var html = fs.readFileSync(__dirname + '/tfw.html', 'utf8');
ko.components.register("tfw-view", {
    viewModel: TfwViewModel,
    template: html
});
